/**
 * @Email : kpozos@ibl.mx
 * @Author: karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 */

import {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {VIEW_TYPE} from "../../../../../enums/ViewType";
import routes from "../../../../../Routes/routes";
import {useNavigate} from "react-router-dom";
import { VISITOR_VIEWS_FROM } from '../../Guard/Model/Model';
import { permissionObj } from '../../../../../Helpers/permission';
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';
import warning from '../../../../../assets/warningImage.png';

const VisitorTabApp = ({setSearchElement, viewOrigin, setShowVisitorModal}) => {
    const { t } = useTranslation();
    // State hooks for managing form data and UI state
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [view, setView] = useState(VIEW_TYPE.LIST.name);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);

    useEffect(() => {
        setSearchElement('');
    }, [view]);

    const goUpdate = (item, disabled) => {
        navigate(routes.visitor.update, { state: { id: item.id, disabled: disabled , viewOrigin: viewOrigin} });
    }
      /**
     * Returns the "childrenNotInformation" JSX for a table component depending on the current view and the presence of data.
     * */
    const getChildrenNotInformation = () => {
        if (viewOrigin === VISITOR_VIEWS_FROM.VISITOR_GUARD) {
            return (
                <div className={view === VIEW_TYPE.GRID.name ? 'content_warning back_card':''}>
                    <div className={view === VIEW_TYPE.GRID.name ? 'info_waring ' : ''}>
                        {view === VIEW_TYPE.GRID.name && <img src={warning} alt='' />}
                        <div className='warning-text'>
                            <p>{t('no_visitors_added')}</p>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <>
                <div className='warning-text'>
                    <p>{t('you_haven_not_created_any_visitor')}</p>
                </div>
                {(DEV || permission?.includes(permissionObj?.WEB_VISITOR_CREATE)) && (
                    <CustomButtonLink
                        splitName={false}
                        id={'btn_vta_create'}
                        card={true}
                        onClick={() => setShowVisitorModal(true)}
                        name={t('create_a_new_visitor')}
                    />
                )}
            </>
        );
    };
    // Return all state and handlers for consumption by component
    return {
        t,
        dispatch,
        view,
        setView,
        goUpdate,
        getChildrenNotInformation
    };
};

export default VisitorTabApp;
